import React, { ReactElement } from 'react';
import { ErrorI } from '../util/functions';
import PasswordField from './PasswordField';

interface DataI {
  password?: string;
  confirmPassword?: string;
}

interface Props {
  children?: React.ReactNode;
  data: DataI;
  error?: ErrorI;
  onPasswordChange: (password: string, strength: number, pointsCheckFail?: boolean) => void;
  onConfirmPasswordChange: (password: string) => void;
  isResetModal?: boolean;
}

export function PasswordUI(props: Props): ReactElement {
  return (
    <React.Fragment>
      <div className="mb-15">
        <PasswordField
          placeholder={props.isResetModal ? 'Enter New Password' : 'Password'}
          value={props.data.password}
          onChange={(e, strength, pointsCheckFail) => {
            if (strength) {
              props.onPasswordChange(e.target.value, strength, pointsCheckFail);
            } else {
              props.onPasswordChange(e.target.value, 0);
            }
          }}
          renderIcon={true}
          lock={true}
          strengthCheck={true}
          isResetModal={props.isResetModal}
          iconStyle={{
            top: '8px',
            right: '5px',
          }}
        />
        <span className="error">{props.error?.password ? props.error?.password : null}</span>
      </div>
      <div className="mb-15">
        <PasswordField
          value={props.data.confirmPassword}
          placeholder="Retype password"
          onChange={(e) => {
            props.onConfirmPasswordChange(e.target.value);
          }}
          renderIcon={true}
          strengthCheck={false}
          isResetModal={props.isResetModal}
          iconStyle={{
            top: '8px',
            right: '5px',
          }}
        />
      </div>
      <span className="error">{props.error?.confirmPassword ? 'Confirm password required' : null}</span>
    </React.Fragment>
  );
}

// if (passwordHintData?.length === 3) {
//   setPassStrengthCheck(3);
//   passwordAbility = 3;
// } else if (passwordHintData?.length === 2) {
//   setPassStrengthCheck(2);
//   passwordAbility = 2;
// } else if (passwordHintData?.length === 1) {
//   setPassStrengthCheck(1);
//   passwordAbility = 1;
// } else {
//   setPassStrengthCheck(0);
//   passwordAbility = 0;
// }
